






import {
    Prop,
    Vue,
    Component
} from "vue-property-decorator";
import BarChartBase from "./charts/BarChartBase.vue";

@Component({
    name: "BarlineChart",
    components: {
        BarChartBase
    }
})
export default class BarlineChart extends Vue {
    @Prop() compData!: any;
}
